import { Controller } from "@hotwired/stimulus"

// Practitioner training wishes: counts the questions answered (one per input
// name, answered when any of its choices is checked), and spells out the area
// behind "Son secteur" from the billing city, which lives in another step.
// Once every question is answered, the section menu (form--section-nav) shows
// the step as done: data-section-nav-complete + a "counted" event.
export default class extends Controller {
  static targets = ["count", "zoneHint", "zoneText"]
  static values = {
    countTemplate: String,
    cityField: String,
    zoneTemplate: String,
    zoneFallback: String,
    mySector: String
  }

  connect () {
    this.form = this.element.closest("form")
    if (!this.form) return

    this.refresh = this.refresh.bind(this)
    this.events = ["input", "change", "address-autocomplete:change"]
    this.events.forEach((event) => this.form.addEventListener(event, this.refresh))
    this.refresh()
  }

  disconnect () {
    this.events?.forEach((event) => this.form.removeEventListener(event, this.refresh))
  }

  refresh () {
    this.refreshCount()
    this.refreshZone()
  }

  refreshCount () {
    const choices = Array.from(this.element.querySelectorAll("input[type=checkbox], input[type=radio]"))
    const names = [...new Set(choices.map((choice) => choice.name))]
    const answered = names.filter((name) => choices.some((choice) => choice.name === name && choice.checked))
    const complete = names.length > 0 && answered.length === names.length

    if (this.element.dataset.sectionNavComplete !== String(complete)) {
      this.element.dataset.sectionNavComplete = complete
      this.dispatch("counted", { detail: { complete } })
    }
    if (!this.hasCountTarget) return

    this.countTarget.textContent = this.countTemplateValue
      .replace("%{count}", answered.length)
      .replace("%{total}", names.length)
  }

  refreshZone () {
    if (!this.hasZoneHintTarget) return

    const mySector = this.element.querySelector(`input[type=radio][value="${this.mySectorValue}"]`)
    this.zoneHintTarget.hidden = !mySector?.checked
    if (this.zoneHintTarget.hidden) return

    const city = document.getElementById(this.cityFieldValue)?.value.trim()
    this.zoneTextTarget.textContent = city ? this.zoneTemplateValue.replace("%{city}", city) : this.zoneFallbackValue
  }
}
